import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Card } from '../models/wallet.interface';
import { LoadingController } from '@ionic/angular';
import { EndpointsService } from './endpoints.service';
import { HttpService } from './http.service';
import { AuthService } from './auth.service';
import { ServiceGenericResponse } from '../models/service-generic.interface';

@Injectable({
  providedIn: 'root'
})
export class WalletService {

  private prepaidCard$: BehaviorSubject<Card> = new BehaviorSubject<Card>({} as Card);
  private prepaidCards$: BehaviorSubject<{ cards: Card[] } | null> = new BehaviorSubject<{ cards: Card[] } | null>(null);

  public cardSelectedEco?: any;
  public referenceCardEco?: any;

  get prepaidCardsObs() {
    return this.prepaidCards$.asObservable();
  }

  set prepaidCard(prepaidCard: Card) {
    this.prepaidCard$.next(prepaidCard);
  }

  get prepaidCardObs() {
    return this.prepaidCard$.asObservable();
  }

  constructor(
    private authService: AuthService,
    private loadingController: LoadingController,
    private endPointsService: EndpointsService,
    private httpService: HttpService
  ) { }

  virtualCardsByUser(): Observable<{ cards: Card[] } | null> {
    console.log(this.authService.uid);
    return this.httpService.get(this.endPointsService.wallets.replace('{ownerId}', this.authService.uid))
      .pipe(
        map((response: any) => {
          return response.data
        })
      );
  }

  async getLatestPrepaidCardsInfo() {
    const loading = await this.loadingController.create();
    await loading.present();

    this.virtualCardsByUser().subscribe((data: { cards: Card[] } | null) => {
      this.prepaidCards$.next(data);
      loading.dismiss();
    }, (error: any) => {
      loading.dismiss();
    });
  }

  addBalance(cardId: string, amount: number, txId: string, userTxId: string) {
    let request = {
      cardId: cardId,
      amount: amount,
      mitId: txId,
      userTransactionId: userTxId
    }

    return this.httpService.put(this.endPointsService.addBalance, request);
  }

  getTransactions(cardId: string) {
    return this.httpService.get(this.endPointsService.carTransactions.replace('{cardId}', cardId));
  }

}
